import { Compressor, TestState, ValidationDeviceStatus } from '@/store/InstallationValidation/constants';
import { t } from 'i18next';

export type GridFlowResponseProps = {
  estimatedFlow: number;
  sensorReadingFlow: number;
};

export type StatusType = 'success' | 'error' | 'testing' | 'not-included';

export const isNoPowerSensorVisible = (compressor: Compressor): boolean => {
  return (
    !compressor.groupPowerSensorId ||
    compressor.LOAD.status === ValidationDeviceStatus.NOT_INCLUDE_SENSOR ||
    compressor.UNLOAD.status === ValidationDeviceStatus.NOT_INCLUDE_SENSOR
  );
};

export const getStatusDisplay = (status: ValidationDeviceStatus, testState: TestState): string => {
  if (status === ValidationDeviceStatus.NOT_TESTED && testState !== TestState.RUNNING) {
    return t('NOT_TESTED');
  }
  switch (status) {
    case ValidationDeviceStatus.PASS:
      return t('PASSED');
    case ValidationDeviceStatus.FAILED:
      return t('FAILED');
    case ValidationDeviceStatus.NOT_TESTED:
      return t('TESTING');
    case ValidationDeviceStatus.NOT_INCLUDE_SENSOR:
      return 'Not Included';
    default:
      return status;
  }
};

export const getStyleType = (status: ValidationDeviceStatus): StatusType => {
  switch (status) {
    case ValidationDeviceStatus.PASS:
      return 'success';
    case ValidationDeviceStatus.FAILED:
      return 'error';
    case ValidationDeviceStatus.NOT_TESTED:
      return 'testing';
    case ValidationDeviceStatus.NOT_INCLUDE_SENSOR:
      return 'not-included';
    default:
      return 'error';
  }
};

export const shouldShowFlowCommentButton = (testState: TestState, flowStatus?: ValidationDeviceStatus): boolean => {
  return (
    (testState === TestState.NEEDS_REVIEW || testState === TestState.SUBMITTED) &&
    (flowStatus === ValidationDeviceStatus.FAILED || flowStatus === ValidationDeviceStatus.NOT_TESTED)
  );
};

export const getFlowCommentButtonText = (testState: TestState, hasComments: boolean) => {
  if (testState === TestState.SUBMITTED) {
    return t('VIEW_COMMENT');
  }
  return hasComments ? t('VIEW_COMMENT') : t('ADD_COMMENT');
};

export const isFlowSumPass = (flowStatus: ValidationDeviceStatus): boolean => {
  return flowStatus === ValidationDeviceStatus.PASS;
};
